import {
  create_title
} from '@/base/titleData';

import pageData from '@/base/pageData'
import { box_shadow_style_add } from "@/base/widgets_data_compatible";
export default {
  img_effects: {
    id: 1,
    formData: {
      effect: 0,//当前选中的特效
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        },
        custom: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        }
      },
      background: {
        radio_val: 'default',
        default: {
          color: "rgba(255, 255, 255, 0)",
        },
        custom: {
          color: "rgba(255, 255, 255, 1)",
        }
      },
      direction: 'left'
    }
  },
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_widgets_infor: {
    //图片高度
    img_size: {
      radio_val: 'default',
      default: {
        width: '100%',
        height: '90%',
      },
      custom: {
        width: '100%',
        height: '90%',
      }
    },
    //图片缩放
    backgroundSize: {
      radio_val: 'default',
      default: {
        backgroundSize: 'cover'
      },
      custom: {
        backgroundSize: 'auto'
      }
    },

    //标题对象
    title: create_title('Catalogue'),
    page: pageData,
    //每行个数
    col_num: {
      radio_val: 'default',
      default: {
        value: 4,
      },
      custom: {
        value: 4,
      }
    },

    //每行间距
    padding: {
      radio_val: 'default',
      default: {
        paddingTop: 10,
        paddingLeft: 10,
      },
      custom: {
        paddingTop: 10,
        paddingLeft: 10,
      }
    },
    // 组合阴影 4.6.7
    ...box_shadow_style_add()
  },
  mb_widgets_infor: {
    //标题对象
    title: create_title('Catalogue'),
  },
  listArr: {
    type: 'custom',
    module_style: '0',
    //直接添加的
    //custom: [14,13,12,11,10],
    custom: [],

    //筛选条件-图册分类
    catalog_id: [],
  },
}



// WEBPACK FOOTER //
// ./src/widgets/basic_atlas_catalog/style.js